export const evisApiConfig = {
    name: "evisData",
    path: "streampreview_dashboard_api/evis",
    getInitialData: "get_evis_groupnames_and_evisids",
    getAllEvisIds: "get_evis_group_names_list",
    getEvisStreamsOfEvisId: "get_host_and_stream_id_by_evisid_and_groupname",
    getEvisStreamAttributes: "get_attributes_by_streamid",
    getEvisStreamThumbnail: "get_evis_zixi_thumbnail",
}
